import { render, staticRenderFns } from "./ModalAddCourseCategory.vue?vue&type=template&id=674d21bd&scoped=true&"
import script from "./ModalAddCourseCategory.vue?vue&type=script&lang=js&"
export * from "./ModalAddCourseCategory.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddCourseCategory.vue?vue&type=style&index=0&id=674d21bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d21bd",
  null
  
)

export default component.exports